const a11yPalette = {
  background: {
    default: '#ffffff',
  },
  text: {
    primary: '#222222',
    secondary: '#ffffff',
  },
  primary: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
  },
  secondary: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
  },
  info: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
    contrastText: '#222222',
  },
  success: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
  },
  error: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
  },
  warning: {
    light: '#222222',
    main: '#222222',
    dark: '#222222',
  },
  a11y: {
    light: '#222222',
    main: '#222222',
    dark: '#ffffff',
    contrastText: '#ffffff',
  },
  gradient: {
    light: '#ffffff',
    main: 'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 100%)',
    dark: 'linear-gradient(90deg, transparent  0%, #fff 50%)',
    contrastText: '#222222',
  },
  grey: {
    50: '#222222',
    100: '#222222',
    200: '#222222',
    300: '#222222',
    400: '#222222',
    500: '#222222',
    600: '#222222',
    700: '#222222',
    800: '#222222',
    900: '#222222',
  },

  light: {
    50: '#FFFFFF',
    100: '#FFFFFF',
    200: '#FFFFFF',
    300: '#FFFFFF',
    400: '#FFFFFF',
    500: '#FFFFFF',
    600: '#FFFFFF',
    700: '#FFFFFF',
    800: '#FFFFFF',
    900: '#FFFFFF',
  },
};

export default a11yPalette;
